import { render, staticRenderFns } from "./DataAnalysis.vue?vue&type=template&id=5586dc96&"
import script from "./DataAnalysis.vue?vue&type=script&lang=ts&"
export * from "./DataAnalysis.vue?vue&type=script&lang=ts&"
import style0 from "./DataAnalysis.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports